import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FaqItemComponent } from './faq-item.component';
import { FaqSchemaComponent } from './faq-schema.component';

/**
 * Each page can have multiple Q&A pairs that comprise an FAQ.
 * The page can set FAQ schemas by using this form:
 *
 * <fl-faq-schema>
 *   <fl-faq-item
 *     question="'Question 1'"
 *     answer="'Answer 1'"
 *   ></fl-faq-item>
 *   <fl-faq-item
 *     question="'Question 2'"
 *     answer="'Answer 2'"
 *   ></fl-faq-item>
 *   // and so on
 * </fl-faq-schema>
 *
 * FaqSchemaComponent handles the construction of the FaqStructuredData object.
 * It also creates the script tag and attaches it to the head.
 */
@NgModule({
  imports: [CommonModule],
  declarations: [FaqItemComponent, FaqSchemaComponent],
  exports: [FaqItemComponent, FaqSchemaComponent],
})
export class FaqSchemaModule {}
